import { useState, useEffect } from 'react';

/**
 * Hook to track the value of a DOM element's attribute.
 */
export function useAttributeValue(ref: React.RefObject<HTMLElement | null>, attributeName: string): string | null {
  const [attributeValue, setAttributeValue] = useState<string | null>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    setAttributeValue(element.getAttribute(attributeName));

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === attributeName) {
          setAttributeValue(element.getAttribute(attributeName));
        }
      });
    });

    observer.observe(element, {
      attributes: true,
      attributeFilter: [attributeName],
    });

    return () => {
      observer.disconnect();
    };
  }, [ref, attributeName]);

  return attributeValue;
}
